import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LoadingState, getError } from 'app/utils/callstate';
import * as _ from 'lodash';
import { PayrollRuleState } from '../payroll.types';
import { RouteState, State, fromPayrollRule } from '../reducers';
import { PayrollRuleEntry } from 'app/api/payroll.rule.api.service';

export const getRouteState = createFeatureSelector<State, RouteState>(
  'payroll'
);

export const selectPayrollRuleState = createSelector(
  getRouteState,
  ({ apiRule }): PayrollRuleState => apiRule
);

export const selectPayrollRule = createSelector(
  selectPayrollRuleState,
  fromPayrollRule.selectAll
);

export const selectPayrollRuleByCompany = (companyId: string) =>
  createSelector(selectPayrollRule, (payrollRules: PayrollRuleEntry[]) =>
    _.filter(payrollRules, ['companyId', companyId])
  );

export const selectPayrollRuleByAxis = (axis: string) =>
  createSelector(selectPayrollRule, (payrollRules: PayrollRuleEntry[]) =>
    _.filter(payrollRules, ['axis', axis])
  );

export const selectPayrollRuleLoading = createSelector(
  selectPayrollRuleState,
  (payrollRuleState) => {
    return payrollRuleState.callState === LoadingState.Loading;
  }
);

export const selectPayrollRuleLoaded = createSelector(
  selectPayrollRuleState,
  (payrollRuleState) => payrollRuleState.callState === LoadingState.Loaded
);

export const selectPayrollRuleError = createSelector(
  selectPayrollRuleState,
  (payrollState) => getError(payrollState.callState)
);
